import React, { useState } from "react";
import { LockClosedIcon } from "@heroicons/react/20/solid";
import { api_interceptor } from "../State/Interceptor/interceptor";
import { SEND_OTP_URL, VERIFY_OTP_URL } from "../State/Interceptor/Url";
import { useDispatch } from "react-redux";
import { LoginAction } from "../State/Action/auth";
import { Link } from "react-router-dom";

export const LoginScreen = () => {
  const [mobile, setmobile] = useState("");
  const [otp, setotp] = useState("");
  const [loading, setloading] = useState(false);
  const [otpSent, setotpSent] = useState(false);

  const dispatch = useDispatch();

  const onSubmit = (e) => {
    e.preventDefault();

    setloading(true);
    api_interceptor
      .post(otpSent ? VERIFY_OTP_URL : SEND_OTP_URL, { mobile, otp })
      .then((res) => {
        if (res.data.status) {
          if (otpSent) {
            dispatch(LoginAction({ token: res.data.token, type: "user" }));
          } else {
            setotpSent(true);
            alert("OTP has been sent to your mobile.");
          }
        } else {
          console.log(res.data);
          alert(res.data.message);
        }
      })
      .catch((err) => {
        alert("Something went wrong");
        console.log(err);
      })
      .finally(() => setloading(false));
  };

  return (
    <div className="flex min-h-screen h-full items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="w-full bg-white p-10 shadow-xl rounded-lg max-w-md space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-semibold tracking-tight text-gray-900">
            Login to your profile
          </h2>
        </div>
        <form onSubmit={onSubmit} className="mt-8">
          <input type="hidden" name="remember" defaultValue="true" />
          <div className=" rounded-md shadow-sm mb-2">
            <div>
              <label htmlFor="mobile" className="sr-only">
                Mobile Number
              </label>
              <input
                id="mobile"
                name="mobile"
                type="tel"
                autoComplete="mobile"
                required
                value={mobile}
                minLength={10}
                maxLength={10}
                onChange={(e) =>
                  !isNaN(e.target.value) ? setmobile(e.target.value) : null
                }
                className="relative block w-full rounded-t-md border-0 px-5 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:z-10 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                placeholder="Mobile Number"
              />
            </div>
            <div>
              <label htmlFor="otp" className="sr-only">
                OTP
              </label>
              {otpSent ? (
                <input
                  id="otp"
                  name="otp"
                  type="text"
                  required
                  value={otp}
                  onChange={(e) =>
                    !isNaN(e.target.value) ? setotp(e.target.value) : null
                  }
                  className="relative block w-full rounded-b-md border-0 px-5 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:z-10 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  placeholder="Enter 4-digit OTP"
                />
              ) : null}
            </div>
          </div>
          <div className="mb-2 flex justify-end">
           <span className="mr-2">New User? </span> <Link to={"/"} className=" text-blue-700">Click here.</Link>
          </div>

          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center">
              <input
                id="remember-me"
                name="remember-me"
                type="checkbox"
                className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
              />
              <label
                htmlFor="remember-me"
                className="ml-2 block text-sm text-gray-900"
              >
                Remember me
              </label>
            </div>
          </div>

          <div>
            <button
              type="submit"
              disabled={loading}
              className="group relative flex w-full justify-center rounded-md bg-indigo-600 py-2 px-3 text-sm font-semibold text-white hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                <LockClosedIcon
                  className="h-5 w-5 text-indigo-500 group-hover:text-indigo-400"
                  aria-hidden="true"
                />
              </span>
              {loading ? "Submitting" : otpSent ? "Verify OTP" : "Send OTP"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
